import React from 'react';
import { projects } from '../data/projects';
import ProjectCard from '../components/ProjectCard';

export default function Projects() {
  return <div className="container"><header className="page-intro"><p className="eyebrow">The portfolio</p><h1>Ideas made useful.</h1><p>AI storytelling, cattle herd management, creative tools and online communities. Explore the products built and operated by WB Tech Ventures.</p></header><section className="project-grid portfolio-grid" aria-label="Our projects">{projects.map((project, index) => <ProjectCard key={project.id} project={project} number={index + 1} />)}</section></div>;
}
